import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  InputType,
  ValidationRule,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_102_add_vehicle: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add vehicle",
    style: { padding: 10 },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "Vehicle_Add",
        TableName: "vehicle_details",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_select_vehicle_make",
            label: "Vehicle make",
            placeholder: "",
            required: true,
            LookupName: "vehicle_make",
            options: [], // Will be populated from lookup
            searchable: true,
            clearable: true,
            Json_Attribute: "vehiclemake",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Vehicle make is required",
              },
            ],
          },
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "s_select_vehicletype",
            label: "Vehicle type",
            placeholder: "",
            required: true,
            lookupName: "vehicletype",
            parentField: "s_select_vehicle_make",
            options: [], // Will be populated from lookup
            Json_Attribute: "vehicletype",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Vehicle type is required",
              },
            ],
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "select_customer",
            label: "Customer",
            placeholder: "",
            required: true,
            lookupName: "customers",
            options: [], // Will be populated from lookup
            searchable: true,
            clearable: true,
            Json_Attribute: "customer_id",
            PopupScreenId: "123",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_country",
            label: "Country",
            placeholder: "",
            required: false,
            lookupName: "country",
            defaultValue: "United Arab Emirates",
            options: [], // Will be populated from lookup
            Json_Attribute: "platesource",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_platecode",
            label: "Emirates/State",
            placeholder: "",
            required: false,
            lookupName: "state",
            parentField: "s_search_country",
            options: [], // Will be populated from lookup
            searchable: true,
            clearable: true,
            Json_Attribute: "platecode",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_reg_no",
            label: "Reg No.",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            disabled: false,
            Json_Attribute: "reg_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Registration number is required",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_enginesize",
            label: "Engine number",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "engine_no",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_chasisno",
            label: "Chassis number",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "chasis_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Chassis number is required",
              },
              {
                rule: ValidationRule.MIN_LENGTH,
                value: 17,
                message: "The Chassis number should be 17 characters long",
              },
              {
                rule: ValidationRule.MAX_LENGTH,
                value: 17,
                message: "The Chassis number should be 17 characters long",
              },
            ],
          },
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "select_vehiclecolor",
            label: "Colour",
            placeholder: "",
            required: false,
            lookupName: "color",
            options: [], // Will be populated from lookup
            Json_Attribute: "color",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_ModelYear",
            label: "Model",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "model_year",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Model is required",
              },
            ],
          },
          {
            componentType: ComponentType.FILES,
            name: "file_mulkkiya",
            label: "Mulkkiya",
            placeholder: "",
            required: false,
            BindValue: "file_mulkkiya",
            Json_Attribute: "mulkkiya_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "file_others",
            label: "Others",
            placeholder: "",
            required: false,
            BindValue: "file_others",
            Json_Attribute: "Others_attachment",
            IsVerticalView: true,
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
